export const searchUrl =
  "http://dev3.dansmultipro.co.id/api/recruitment/positions.json";

export const detailUrl =
  "http://dev3.dansmultipro.co.id/api/recruitment/positions/";
